import { render, staticRenderFns } from "./arzypto_info.vue?vue&type=template&id=8312e7f2&"
import script from "./arzypto_info.vue?vue&type=script&lang=js&"
export * from "./arzypto_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports